module.exports = __webpack_public_path__ + "static/media/coins_icon_order.dff37c01.svg";